import { render } from "./DestinationsPinned.vue?vue&type=template&id=279fb77c"
import script from "./DestinationsPinned.vue?vue&type=script&lang=js"
export * from "./DestinationsPinned.vue?vue&type=script&lang=js"
script.render = render

export default script